import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalConfirm.css';
import { Button } from '@material-ui/core';
import { LetterX } from 'tabler-icons-react';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '760px',
        height: '530px',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        // border: '2px solid #000',
        // boxShadow: theme.shadows[2],
    },
}));

export default function ModalTermEsp() {
    const { setOpenTermEsp, openTermEsp, setConfirmTermEsp } = useGeneral();
    const classes = useStyles();

    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);

    const handleCloseAll = () => {
        setOpenTermEsp(false);
    };

    const handleClose = () => {
        setOpenTermEsp(false);
    };

    const body = (
        <div style={modalStyle} className={classes.paper}>
            <div className="modalConf-head" style={{ backgroundColor: '#00638D' }}>
                <div className="modalConf-text" style={{ color: '#fff' }}>
                    <h4 className="modalConf-text-field">Terminar Paro Especial</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleCloseAll}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>
            <div className="modalConf-body">
                <div className="modalConf-body-text">
                    <h1>Está seguro que desea Terminar el paro especial?</h1>
                </div>
                <div className="modalConf-body-buttons">
                    <div className="modalConf-body-buttons-first">
                        <Button
                            className="modalM-body-buttonS"
                            style={{ backgroundColor: '#00638D' }}
                            onClick={(e) => {
                                handleClose();
                                setConfirmTermEsp(true);
                            }}
                        >
                            <h1 style={{ color: '#fff' }}>Confirmar</h1>
                        </Button>
                    </div>

                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC"
                            style={{
                                borderRadius: '3px',
                                borderWidth: '2px',
                                borderStyle: 'solid',
                                borderColor: '#00638D',
                            }}
                            onClick={(e) => handleClose()}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openTermEsp}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
